import { renderSlot as _renderSlot, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-gray.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-9fb87d4c")

_pushScopeId("data-v-9fb87d4c")
const _hoisted_1 = { class: "relative inline-block" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "pill-overlay-trigger-content" }, "Select", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3.5 h-3.5"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "px-3 py-2" }, "Content", -1)
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row gap-x-2 py-2 px-4 w-full",
  style: {"box-shadow":"0px -1px 4px 0px #1A142126"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      type: "button",
      class: ["pill-overlay-trigger inline-flex items-center gap-1.5 rounded-full border px-4 py-2 text-sm font-medium transition-colors", 
        _ctx.isOpen
          ? 'pill-overlay-trigger-open'
          : _ctx.active
          ? 'pill-overlay-trigger-active'
          : 'pill-overlay-trigger-default'
      ],
      disabled: _ctx.disabled,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _renderSlot(_ctx.$slots, "trigger", {}, () => [
        _hoisted_2
      ], {}, true),
      (_ctx.showClear)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            class: "ml-1 flex items-center",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)), ["stop"]))
          }, [
            _renderSlot(_ctx.$slots, "clear", {}, () => [
              _hoisted_3
            ], {}, true)
          ]))
        : _createCommentVNode("", true)
    ], 10, ["disabled"]),
    _createVNode(_Transition, { name: "pill-overlay-fade" }, {
      default: _withId(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: ["pill-overlay-panel absolute overflow-hidden rounded-xl border border-gray-lp-1400 bg-white shadow-lg", _ctx.overlayPositionClass],
              role: "dialog",
              "aria-modal": "true"
            }, [
              _renderSlot(_ctx.$slots, "content", {
                close: _ctx.close,
                toggle: _ctx.toggle
              }, () => [
                _hoisted_4
              ], true),
              (_ctx.showActions)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode("button", {
                      class: ["text-white py-1.5 w-full rounded-md text-xs font-semibold", _ctx.disabledReset ? 'text-gray-lp-600' : 'text-red-lp-2400'],
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args))),
                      disabled: _ctx.disabledReset
                    }, " Reset ", 10, ["disabled"]),
                    _createVNode("button", {
                      class: ["text-white py-1.5 w-full rounded-md text-xs font-semibold", _ctx.disabledApply ? 'bg-gray-lp-600' : 'bg-red-lp-2400'],
                      disabled: _ctx.disabledApply,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
                    }, _toDisplayString(_ctx.$t("cargo.v2.flight.search.action.apply")), 11, ["disabled"])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 512)), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isOpen) {
          _ctx.close();
        }
      }
    ]
  ])
})